
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'Footer',
    setup () {
        const version = process.env.PACKAGE_VERSION

        return {
            version
        }
    }
})
